export interface Asset {
  id: string;
  name: string;
  asset_type: string;
  serial_number?: string;
  model_number?: string | null;
  manufacturer?: string;
  property_id?: string;
  status: "Active" | "Out-of-Service" | "Maintenance" | "Decommissioned";
  last_maintenance?: string;
  next_maintenance?: string;
  purchase_date?: string;
  purchase_price?: number;
  warranty_expires?: string;
  notes?: string;
  asset_code?: string | null;
  condition?: string | null;
  installation_date?: string | null;
  category_id?: string | null;
  category_attributes?: any;
}

export interface CategoryWithSchema {
  id: string;
  name: string;
  schema: any;
}

export interface EditAssetFormData {
  name: string;
  manufacturer: string;
  model_number: string;
  serial_number: string;
  status: Asset["status"];
  purchase_date: Date | undefined;
  purchase_price: string;
  warranty_expires: Date | undefined;
  last_maintenance: Date | undefined;
  next_maintenance: Date | undefined;
  notes: string;
  asset_code: string;
  condition: string;
  installation_date: Date | undefined;
}

export const ASSET_STATUSES = ["Active", "Out-of-Service", "Maintenance", "Decommissioned"];
export const CONDITION_OPTIONS = ["New", "Good", "Fair", "Poor"] as const;
